import { createEvent, restore, sample } from 'effector'
import { SectionById, EditSection } from './types'
import { fx, path } from '../../../../libs'
import { $params, toPath } from '../../../../features/router'

export const sectionMounted = createEvent()

export const setSection = createEvent<SectionById>()

export const submitEditSection = createEvent<EditSection>()

export const sectionListForSelectMounted = createEvent()

export const $section = restore(setSection, {
  id: '',
  name: '',
})

export const getSection = fx<void, SectionById>({
  method: 'GET',
  url: '/finance/section/{sectionID}',
})

export const editSection = fx<Omit<EditSection, 'id'>, void>({
  method: 'PUT',
  url: '/finance/section/{sectionID}',
})

sample({
  clock: sectionMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.sectionID
    }
    return {
      url: `/finance/section/${id}`,
    }
  },
  target: getSection,
})

sample({
  clock: [getSection.doneData],
  fn: (doneData) => doneData.body,
  target: [setSection],
})

sample({
  clock: submitEditSection,
  fn: (section) => {
    return {
      url: `/finance/section/${section.id}`,
      body: { name: section.name },
    }
  },
  target: editSection,
})

sample({
  clock: [editSection.doneData],
  target: toPath.prepend(path.finSystem.sections.entry),
})
